<template>
<!-- Status -->
<div class="w-full grid justify-items-center control_section">
	<ejs-dialog
		id="status-2-dialog"
		:buttons='alertDlgButtons_2'
		ref="alertDialog_2"
		v-bind:visible="false"
		:header='alertHeader'
		:animationSettings='animationSettings'
		:content='alertContent'
		:showCloseIcon='false'
		target='.control_section'
		width='550px'
		max-height='none'
		:isModal='true'
	>
	</ejs-dialog>
	<ejs-dialog
		id="status-3-dialog"
		:buttons='alertDlgButtons_3'
		ref="alertDialog_3"
		v-bind:visible="false"
		:header='alertHeader'
		:animationSettings='animationSettings'
		:showCloseIcon='false'
		target='.control_section'
		width='550px'
		:isModal='true'
	>
		<panel addclass="h-full">
			<div class="flex flex-col items-center">
				<div id="status-3-dialog-form">
					<validation><ejs-combobox name="dlg_reason" allowCustom='true' :change="handleReasonChange" :dataSource='reasonsData' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.reason_title')" :showClearButton="true" v-model:value="this.reason"></ejs-combobox></validation>
					<ejs-combobox ref="sub_reason" name='dlg_sub_reason' :dataSource='subReasonsData' :fields='fields' floatLabelType="Auto" :placeholder="$t('eny.sub_reason_title')" :showClearButton="true" :allowCustom="false" v-model:value="this.subReasons"></ejs-combobox>
					<ejs-textbox :multiline="true" name="dlg_text" floatLabelType="Auto" :placeholder="$t('eny.comment_title')" v-model:value="this.comment"></ejs-textbox>
				</div>
			</div>
		</panel>
	</ejs-dialog>
	<panel :title="$t('eny.status')" addclass="mt-4 w-full max-w-[1300px]">
		<div class="rounded-lg px-6 form-group pt-7 mx-6 grid justify-items-center">
			<div class='eny-radio-toolbar max-w-[1600px] flex flex-col sm:flex-row' :class="{ 'no-hover': statusChangeDisabled }">
				<div v-for="status in statuses" :key="status.value" class="eny-radio" >
					<input type="radio" :id="'status_filter_' + status.value" name="status_filter" :value=status.value v-model="status_loc" :disabled="statusChangeDisabled" @change="onStatusChanged($event)"/>
					<label :for="'status_filter_' + status.value"><span>{{status.label }}</span></label>
				</div>
			</div>
			<div v-if="status_loc === 3" class="text-color-text font-semibold text-3xl rounded-lg flex items-center mt-4 flex-col">
				<form id="reasons-form">
					<div class="w-full flex justify-center" bis_skin_checked="1">
						<div class="font-bold text-4xl" bis_skin_checked="1">{{ $t('eny.reason_of_cancellation') }}</div>
					</div>
					<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-4">
						<div class='px-4'>{{ $t('eny.reason_title') }}</div>
						<div v-if="reasonIsSet" class="items-center mx-4 col-start-3 col-span-3">
							<ejs-maskedtextbox id="reason" name="reason" floatLabelType="Auto" placeholder="" readonly="true" cssClass="e-text-left e-text-readonly" v-model:value="reasonField"></ejs-maskedtextbox>
						</div>
						<div v-else class="items-center mx-4 col-start-3 col-span-3">
							<ejs-combobox  name="reason" allowCustom='true' :change="handleReasonChange" :dataSource='reasonsData' :fields='fields' floatLabelType="Auto" placeholder="" :showClearButton="true" v-model:value="this.reason"></ejs-combobox>
						</div>
					</div>
					<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-4">
						<div class='px-4'>{{ $t('eny.sub_reason_title') }}</div>
						<div v-if="subReasonIsSet" class="items-center mx-4 col-start-3 col-span-3">
							<ejs-maskedtextbox id="sub_reason" name="sub_reason" floatLabelType="Auto" placeholder="" readonly="true" cssClass="e-text-left e-text-readonly" v-model:value="subReasonField"></ejs-maskedtextbox>
						</div>
						<div v-else class="items-center mx-4 col-start-3 col-span-3">
							<ejs-combobox ref="sub_reason" name='sub_reason' :dataSource='subReasonsData' :fields='fields' floatLabelType="Auto" placeholder="" :showClearButton="true" :allowCustom="false" v-model:value="this.subReasons"></ejs-combobox>
						</div>
					</div>
					<div class="w-full grid grid-flow-col items-justify-center grid-cols-5 gap-4 mt-4">
						<div class='px-4'>{{ $t('eny.comment_title') }}</div>
						<div class="items-center mx-4 col-start-3 col-span-3">
							<ejs-textbox :multiline="true" name="text" floatLabelType="Auto" placeholder="" v-model:value="this.comment"></ejs-textbox>
						</div>
					</div>
					<div class="w-full md:px-20 pt-5 flex flex-row justify-center">
						<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="onSave">{{$t('eny.save')}}</button>
					</div>
				</form>
			</div>
		</div>
	</panel>
</div>
<!-- Desired conditions -->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.desired_conditions')" addclass="mt-4 w-full max-w-[1300px]">
		<rate :amount="amount" :amount_view="amount_view" :duration="duration" :incl_insurance="incl_insurance">
			<!-- Include insurance -->
			<div class="pt-4 flex flex-col items-center">
				<ejs-checkbox id="incl_insurance" name="incl_insurance" :label="$t('eny.incl_insurance')" v-model:checked="request_loc.incl_insurance" :value="request_loc.incl_insurance ? 1 : 0" v-on:click="updateInclInsurance"></ejs-checkbox>
			</div>
		</rate>
	</panel>
</div>
<!-- Possible Conditions -->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.possible_conditions')" addclass="mt-4 w-full max-w-[1300px]">
		<!-- Suggested credit amount -->
		<div class="text-color-text font-semibold text-3xl rounded-lg flex items-center mt-4">
			<div class="w-full grid grid-flow-col items-justify-center md:grid-cols-5 gap-4">
				<div class='px-4'>{{ $t('eny.amount') }} CHF</div>
				<div class="items-center mx-4 md:col-start-3">
					<ejs-maskedtextbox id="suggested_credit_amount" name="suggested_credit_amount" floatLabelType="Auto" placeholder="" cssClass="e-text-center w-full" v-model:value="request_loc.suggested_credit_amount"></ejs-maskedtextbox>
				</div>
				<div class="md:col-start-4 lg:col-start-5">
					<button type="button" class="eny-btn-blue px-8 py-2 text-2xl font-bold" @click="calculateAll">{{$t('eny.save')}}</button>
				</div>
			</div>
		</div>
		<!-- Suggested credit duration -->
		<div class="text-color-text font-semibold text-3xl rounded-lg flex items-center mt-4">
			<div class="w-full grid grid-flow-col items-justify-center md:grid-cols-5 gap-4">
				<div class='px-4'>{{ $t('eny.duration') }}</div>
				<div class="items-center mx-4 md:col-start-3">
					<ejs-maskedtextbox id="suggested_credit_duration" name="suggested_credit_duration" floatLabelType="Auto" placeholder="" cssClass="e-text-center w-full" v-model:value="request_loc.suggested_credit_duration"></ejs-maskedtextbox>
				</div>
			</div>
		</div>
		<!-- Interest rate -->
		<div class="text-color-text font-semibold text-3xl rounded-lg flex items-center mt-4">
			<div class="w-full grid grid-flow-col items-justify-center md:grid-cols-5 gap-4">
				<div class='px-4'>{{ $t('eny.interestrate') }}</div>
				<div class="items-center mx-4 md:col-start-3">
					<ejs-maskedtextbox id="credit_worth" name="credit_worth" floatLabelType="Auto" placeholder="" cssClass="e-text-center w-full" v-model:value="request_loc.interest"></ejs-maskedtextbox>
				</div>
			</div>
		</div>
		<!-- Allowance -->
		<div class="text-color-text font-semibold text-3xl rounded-lg flex items-center mt-4">
			<div class="w-full grid grid-flow-col items-justify-center md:grid-cols-5 gap-4">
				<div class='px-4'>{{ $t('eny.allowance') }}</div>
				<div class="items-center mx-4 md:col-start-3">
					<ejs-maskedtextbox id="allowance" name="allowance" floatLabelType="Auto" placeholder="" readonly="true" cssClass="e-text-center e-text-readonly" v-model:value="allowance.amount"></ejs-maskedtextbox>
				</div>
				<div class="md:col-start-4 lg:col-start-5"></div>
			</div>
		</div>
		<!-- Conditions Overview -->
		<div id="eny_dashboard_overview" class="pt-8">
			<ejs-grid ref="grid" :dataSource='conditionsData' :allowPaging='true' gridLines='Both' :allowTextWrap='true' allowSorting='true'
			          :pageSettings='pageSettings' :rowSelected='rowSelected'>
				<e-columns>
					<e-column field='amount' :headerText="$t('eny.amount')"></e-column>
					<e-column field='duration' :headerText="$t('eny.duration')"></e-column>
					<e-column field='monthly_rate' :headerText="$t('eny.monthly_rate')" hideAtMedia='(min-width: 800px)'></e-column>
					<e-column field='ppi' :headerText="$t('eny.ppi')" hideAtMedia='(min-width: 800px)'></e-column>
					<e-column field='monthly_cost' :headerText="$t('eny.monthly_cost')"></e-column>
				</e-columns>
			</ejs-grid>
		</div>
	</panel>
</div>
<!-- Intrum Result -->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.intrum_result')" addclass="mt-4 w-full max-w-[1300px]">
		<div class="text-color-text font-semibold text-3xl mt-4">
			<!-- Credit worthiness -->
			<div class="w-full flex flex-col sm:flex-row justify-items-start sm:justify-items-center">
				<div class='px-4 py-1 min-w-[250px] w-[250px] flex items-center'>{{ $t('eny.credit_worthiness') }}</div>
				<div class="grow flex flex-row justify-between items-center mt-2 sm:mt-0">
					<div class="grow mx-4 flex justify-start sm:justify-center">
						<ejs-maskedtextbox id="recommendation" name="recommendation" floatLabelType="Auto" placeholder="" readonly="true" cssClass="e-text-center e-text-readonly md:max-w-[200px]" v-model:value="request_loc.recommendation"></ejs-maskedtextbox>
					</div>
					<button type="button" class="eny-btn-blue p-2 mr-4 text-2xl font-bold w-[160px] min-w-[160px]" @click="updateRecommendation">{{$t('eny.calculate')}}</button>
				</div>
			</div>
		</div>
	</panel>
</div>
<!-- Privacy consented -->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.privacy_consent')" addclass="mt-4 w-full max-w-[1300px]">
		<div class="text-color-text font-semibold text-3xl mt-4">
			<!-- Consented at -->
			<div class="w-full flex flex-col sm:flex-row justify-items-start sm:justify-items-center">
				<div class='px-4 py-1 min-w-[250px] w-[250px] flex items-center'>{{ $t('eny.forward') }}</div>
				<div class="grow flex flex-row justify-between items-center mt-2 sm:mt-0">
					<div class="grow mx-4 flex justify-start sm:justify-center">
						<ejs-maskedtextbox id="consented_at" name="consented_at" floatLabelType="Auto" placeholder="" readonly="true" cssClass="e-text-center e-text-readonly md:max-w-[200px]" v-model:value="user.consented_at_ui"></ejs-maskedtextbox>
					</div>
					<div class="p-2 mr-4 hidden md:block md:w-[160px] md:min-w-[160px]" />
				</div>
			</div>
		</div>
	</panel>
</div>
<!-- Has eny credit card -->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.has_eny_credit_card')" addclass="mt-4 w-full max-w-[1300px]">
		<div class="text-color-text font-semibold text-3xl mt-4">
			<div class="w-full flex justify-center items-center grid-cols-5 gap-4 mt-3">
				<div class="items-center mx-4 col-start-3 col-span-3">
					<div class='eny-radio-toolbar w-full text-base'>
						<div class="eny-radio w-96">
							<input type="radio" id="radio_has_eny_credit_card_1" name="has_eny_credit_card" value='1' v-model="user.has_eny_credit_card" />
							<label for="radio_has_eny_credit_card_1"><span>{{$t('eny.yes')}}</span></label>
						</div>
						<div class="eny-radio w-96">
							<input type="radio" id="radio_has_eny_credit_card_0" name="has_eny_credit_card" value='0' v-model="user.has_eny_credit_card" />
							<label for="radio_has_eny_credit_card_0"><span>{{$t('eny.no')}}</span></label>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- save button -->
		<div class="w-full md:px-20 pt-5 flex flex-row justify-center gap-2">
			<button class="eny-btn-blue px-8 py-2 text-2xl font-bold" type="button" @click="onSaveCreditCard">{{$t('eny.save')}}</button>
		</div>
	</panel>
</div>
<!-- final Conditions -->
<div class="w-full grid justify-items-center">
	<panel :title="$t('eny.final_conditions')" addclass="my-4 w-full max-w-[1300px]">
		<final_conditions></final_conditions>
	</panel>
</div>
</template>

<script>
import { GridComponent, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-vue-grids';
import {FormValidator, MaskedTextBoxComponent, TextBoxComponent} from '@syncfusion/ej2-vue-inputs';
import { ComboBoxComponent } from "@syncfusion/ej2-vue-dropdowns";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { CheckBoxComponent } from "@syncfusion/ej2-vue-buttons";
import { DialogComponent } from "@syncfusion/ej2-vue-popups";
import { useI18n } from 'vue-i18n'
import Panel from "../../Base/Panel.vue";
import DashboardFinalConditions from './DashboardFinalConditions.vue';
import useNotification from "../../hooks/useNotification";
import useUtils from '../../hooks/useUtils';
import { mapGetters } from 'vuex';
import Rate from "../Offer/Rate.vue";
import Validation from "../../Base/Validation.vue";

export default {
	name: "DashboardDetail",
	components: {
		'validation': Validation,
		'panel': Panel,
		'ejs-maskedtextbox': MaskedTextBoxComponent,
		'ejs-combobox': ComboBoxComponent,
		'ejs-grid': GridComponent,
		'ejs-checkbox': CheckBoxComponent,
		'ejs-textbox': TextBoxComponent,
		'e-columns': ColumnsDirective,
		'e-column': ColumnDirective,
		'ejs-dialog': DialogComponent,
		'rate' : Rate,
		'final_conditions': DashboardFinalConditions,
	},
	setup() {
		const { showNotification } = useNotification();
		const { sleep, floor, round, formatAmount } = useUtils();
		return {
			showNotification,
			sleep,
			floor,
			round,
			formatAmount
		}
	},
	created() {
		if (this.$route.params.uid && this.request.user_id!=this.$route.params.uid) {
			this.$store.dispatch('customer/load', this.$route.params.uid);
		}
	},
	mounted() {
		if (this.request) {
			this.request_loc = this.request;
			this.reason = this.request.reason;
			this.subReasons = this.request.sub_reason;
			this.comment = this.request.comment;
		}
		this.calculateAll(false);
		this.showAllowanceDetails();

		var statusDialogOptions = {
			rules: {
				dlg_reason: { required: [true, this.$t('eny.tpl_notempty_error_msg', {field: this.$t('eny.reason_title')})] },
			},
			customPlacement: this.showValidationError,
		};
		this.statusDialogFormObject = new FormValidator("#status-3-dialog-form", statusDialogOptions);
	},
	data() {
		return {
			request_loc: {},
			reason: null,
			statuses: JSON.parse(this.$t('eny.statuses')),
			// controls' data
			pageSettings: { pageSizes: true, pageCount: 4, pageSize: 10 },
			conditionsData : {},
			fields : { text: 'label', value: 'value' },
			reasonsData: JSON.parse(this.$t('eny.reasons')),
			subReasons: "",
			comment: "",
			// dialog data
			alertHeader: this.$t('eny.change_status_prompt_title'),
			alertContent: '',
			animationSettings: { effect: 'None' },
			alertDlgButtons_2: [
				{ click: this.modalDlgCancelClick, buttonModel: { content: this.$t('eny.cancel_btn'), isPrimary: false } },
				{ click: this.modalDlg2OKClick, buttonModel: { content: this.$t('eny.ok_btn'), isPrimary: true } }
			],
			alertDlgButtons_3: [
				{ click: this.modalDlgCancelClick, buttonModel: { content: this.$t('eny.cancel_btn'), isPrimary: false } },
				{ click: this.modalDlg3OKClick, buttonModel: { content: this.$t('eny.ok_btn'), isPrimary: true } }
			],
			status_loc: null,
			next_status: null,
			statusDialogFormObject: {},
		};
	},
	methods: {
		handleReasonChange(){
			this.$refs.sub_reason.clear();
		},
		rowSelected: function(args) {
		},
		calculateAll: function(store_interest = true) {
			const conditionsData = [];
			if (this.allowance) {
				const interest = this.request_loc.interest / 100;
				const allowance = this.allowance.amount ? this.allowance.amount : 0;
				const durations = [12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84];
				durations.forEach(
					duration => {
						conditionsData.push(this.calculate(duration, interest, allowance));
					}
				);
			}
			if (store_interest) {
				this.$store.dispatch('customer/store_interest', { request: this.request_loc });
			}
			this.conditionsData = conditionsData;
		},
		calculate: function(duration, interest, allowance) {
			// = (1 + Effektiver Zinssatz) ^ (1/12) - 1
			const nominal_interest_rate_monthly = Math.pow(1 + interest, 1/12) - 1;
			const duration_calc = (duration < 36) ? duration : 36;
			const max_loan_amount = this.floor(allowance * (1 - Math.pow(1 + nominal_interest_rate_monthly, -duration_calc)) / nominal_interest_rate_monthly, 1000);
			// = (Nettokreditsumme x Nominaler Zinssatz /12 ) / (1- (1+ Nominaler Zinssatz /12) ^ (- Laufzeit))
			const month_rent = this.round((max_loan_amount * nominal_interest_rate_monthly) / (1 - Math.pow((1 + nominal_interest_rate_monthly), -duration)), 0.05);
			// = Monatliche Rate x Laufzeit - Nettokreditsumme
			const total_interest_cost = this.round(month_rent * duration - max_loan_amount, 0.05);
			// =7.5% von der monatlichen Rate
			const ppi = this.round(month_rent * 0.075, 0.05);
			// =Monatliche Rate + Restschuuldversicherung
			const total = month_rent + ppi;
			return { amount: max_loan_amount, duration: duration, monthly_rate: this.formatAmount(month_rent), ppi: this.formatAmount(ppi), monthly_cost: this.formatAmount(total) };
		},
		updateRecommendation: function() {
			this.$store.dispatch('customer/update_recommendation', {request: this.request_loc});
		},
		updateInclInsurance: function() {
			this.$store.dispatch('customer/update_incl_insurance', {request: this.request_loc});
		},
		onSave() {
			let data = {
				'reason' : this.reason,
				'subReason' : this.subReasons,
				'comment': this.comment
			};
			data.requestId = this.request.id;
			return this.$store.dispatch('customer/saveCancellationsReasons', data);
		},
		onSaveCreditCard() {
			this.$store.dispatch('customer/saveHasEnyCreditCard', this.user);
		},
		showAllowanceDetails() {
			if (this.allowance.data) {
				const allowance_data = JSON.parse(this.allowance.data);
				console.log(allowance_data)
				const dataToConsole = {
					average_salary: allowance_data.average_salary,
					add_income_monthly: allowance_data.add_income_monthly,
					side_job: allowance_data.side_job,
					average_partner_salary: allowance_data.average_partner_salary,
					main_salary: allowance_data.main_salary + " = " + allowance_data.average_salary + "(average_salary) + " + allowance_data.add_income_monthly + "(add_income_monthly)",
					earnings_monthly: allowance_data.earnings_monthly + " = " + allowance_data.main_salary + "(main_salary) + " + allowance_data.side_job + "(side_job) + " + allowance_data.average_partner_salary + "(average_partner_salary)",
					children_expenses: allowance_data.children_expenses,
					tax: allowance_data.tax,
					expenses_total:
						allowance_data.expenses_total + " = " + allowance_data.living_condition_basic_amount + "(living_condition_basic_amount) + " + allowance_data.children_expenses + "(children_expenses) + " +
						allowance_data.tax + "(tax) + " + allowance_data.housing_expenses + "(housing_expenses) + " + allowance_data.health_insurance + "(health_insurance) + " + allowance_data.open_loan_sum + "(open_loan_sum) + " +
						allowance_data.open_balances_sum + "(open_balances_sum) + " + allowance_data.misc + "(misc)",
					totalIncome: allowance_data.totalIncome + " = " + allowance_data.main_salary + "(main_salary) + " + allowance_data.side_job + "(side_job)",
					expenses_partner: allowance_data.expenses_partner,
					allowance_before_paying_open_obligations: allowance_data.allowance_before_paying_open_obligations + " = " + allowance_data.totalIncome + "(totalIncome) + " + allowance_data.expenses_partner + "(expenses_partner) - " + allowance_data.expenses_total + "(expenses_total)",
					allowance: allowance_data.allowance + " = " + allowance_data.allowance_before_paying_open_obligations + "(allowance_before_paying_open_obligations)"
				};
				console.log(dataToConsole); // This is a feature! Don't remove this output.
			}
		},
		showValidationError: function(element, errorElement) {
			const el=element.closest('.validation-group').querySelector('.error-element');
			if (el && errorElement) {
				el.appendChild(errorElement);
			}
		},
		modalDlgCancelClick: function() {
			this.status_loc = this.request.status;
			this.$refs.alertDialog_2.hide();
			this.$refs.alertDialog_3.hide();
		},
		modalDlg2OKClick: function() {
			this.onSave().then(() => {
				this.$store.dispatch('customer/store_status', {status: this.next_status, reason: null});
				this.$refs.alertDialog_2.hide();
			});
		},
		modalDlg3OKClick: function() {
			if (this.statusDialogFormObject.validate()) {
				this.onSave().then(() => {
					this.$store.dispatch('customer/store_status', {status: this.next_status, reason: this.reason});
					this.$refs.alertDialog_3.hide();
				});
			}
		},
		onStatusChanged: function (event) {
			const value = event.target.value;
			if (value < 2) {
				//if (value !== this.request.status) {
					this.$store.dispatch('customer/store_status', {status: value, reason: null});
				//}
			} else {
				// show confirmation popup before setting to "abgeschlossen" or "storniert" status
				this.next_status = value;
				if (value == 2) {
					this.alertContent = this.$t('eny.change_status_prompt');
					this.$refs.alertDialog_2.show();
				} else if (value == 3) {
					this.alertContent = "";
					this.$refs.alertDialog_3.show();
				}
			}
		},
	},
	computed: {
		...mapGetters('customer', ['user', 'amount_view', 'request', 'allowance', 'loading', 'success', 'message']),
		statusChangeDisabled() {
			return false; // this.request.status == 2 || this.request.status == 3;
		},
		amount() {
			return this.request.credit_amount;
		},
		duration() {
			return this.request.credit_duration;
		},
		incl_insurance() {
			return this.request.incl_insurance;
		},
		subReasonsData() {
			switch (this.reason) {
				case "decline":
					return JSON.parse(this.$t('eny.reason_decline'));
				case "refusal":
					return JSON.parse(this.$t('eny.reason_refusal'));
				default:
					return {};
			}
		},
		reasonIsSet(){
			if (this.request_loc.reason){
				return true;
			} else {
				return false;
			}
		},
		subReasonIsSet(){
			if (this.request_loc.sub_reason){
				return true;
			} else {
				return false;
			}
		},
		reasonField(){
			if (!this.reason) {
				return '';
			}
			let reason = this.reasonsData.find(o => o.value === this.reason);
			return reason.label;
		},
		subReasonField(){
			if (!this.subReasons){
				return '';
			}
			let reason = this.subReasonsData.find(o => o.value === this.subReasons);
			return reason.label;
		}
	},
	watch: {
		message(value, oldValue) {
			if (value!=='') {
				const type=this.success ? 'info' : 'error';
				this.showNotification(value, type, 5);
			}
		},
		loading(value, oldValue) {
			if (!value && oldValue && this.success) { // loading => not loading && success
				this.request_loc = this.request;
				this.status_loc = this.request.status;
			}
		}
	}
}
</script>

<style>
#status-2-dialog,
#status-3-dialog {
	max-height: max-content !important;
}
.e-grid .e-rowcell {
	font-size: 12px;
}
.e-float-input, .e-float-input.e-control-wrapper {
	margin-top: 1px;
}
.e-text-center .e-maskedtextbox {
	@apply text-center;
}
.e-text-readonly .e-maskedtextbox {
	@apply !text-color-text;
}
</style>
